import React, { useEffect, useState } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const IntakeFormPage16 = () => {
  const [storedData, setStoredData] = useState<Record<string, any>>({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [appointmentUrl, setAppointmentUrl] = useState<string>("");
  const isStaging = process.env.REACT_APP_ENV === "staging";
  const appointmentTypeId = isStaging
    ? process.env.REACT_APP_STAGING_APPOINTMENT_TYPE_ID
    : process.env.REACT_APP_PROD_APPOINTMENT_TYPE_ID;
  const providerId = isStaging
    ? process.env.REACT_APP_STAGING_PROVIDER_ID
    : process.env.REACT_APP_PROD_PROVIDER_ID;

  const openloopurl = isStaging
    ? process.env.REACT_APP_STAGING_OPENLOOP_URL
    : process.env.REACT_APP_PROD_OPENLOOP_URL;

  useEffect(() => {
    const allValues: Record<string, any> = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        try {
          allValues[key] = JSON.parse(value || "");
        } catch {
          allValues[key] = value;
        }
      }
    }
    setStoredData(allValues);

    const firstName = allValues.firstName?.value;
    const lastName = allValues.lastName?.value;
    const email = allValues.email?.value;
    const phoneNumber = allValues.phone?.value;
    const state = allValues.state?.value;

    const url = `${openloopurl}/book-appointment?appointmentTypeId=${appointmentTypeId}&providerId=${providerId}&firstName=${encodeURIComponent(
      firstName
    )}&lastName=${encodeURIComponent(
      lastName
    )}&phoneNumber=${encodeURIComponent(
      phoneNumber
    )}&email=${encodeURIComponent(email)}&state=${encodeURIComponent(
      state
    )}&redirectUrl=https://claya-stage-react-89d77bb7e7c8.herokuapp.com/complete-intake/thank-you`;
    setAppointmentUrl(url);
    localStorage.setItem("complete-intake-step13", "true");
  }, []);

  useEffect(() => {
    const completeIntakeStep12 = localStorage.getItem("complete-intake-step12");
  
    if (localStorage.getItem("intakeFormSubmitted") === "true") {
      navigate("/complete-intake/step-13", { replace: true });
  
      // Prevent back navigation
      const handlePopState = () => {
        navigate("/complete-intake/step-13", { replace: true });
      };
  
      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }
  
    if (completeIntakeStep12) {
      navigate("/complete-intake/step-13", { replace: true });
    } else {
      navigate("/complete-intake/step-12", { replace: true });
    }
  }, []);

  return (
    <PageWrapper>
      <div
        className="signup-page-container container"
        style={{ position: "relative" }}
      >
        {loading && (
          <div
            style={{
              position: "absolute",
              top: "0",
              width: "100vw",
              height: "50vh",
              zIndex: "9999",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={60} sx={{ color: "rgb(137, 67, 149)" }} />
          </div>
        )}
        <iframe
          src={appointmentUrl}
          // title="Book Appointment Widget"
          width="100%"
          height="800px"
          style={{
            border: "none",
          }}
          allowFullScreen
          onLoad={() => setLoading(false)}
        />
      </div>
    </PageWrapper>
  );
};
export default IntakeFormPage16;
